import { Link } from "react-router-dom";
import PixelSnow from "../components/PixelSnow";
import "./TestingPageFive.css";

export default function TestingPageFive() {
  return (
    <div className="testing5-page">
      <div
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
      >
        <PixelSnow
          color="#ffffff"
          flakeSize={0.017}
          minFlakeSize={1.25}
          pixelResolution={330}
          maxDevicePixelRatio={1}
          speed={1.25}
          density={0.3}
          direction={125}
          brightness={1}
          depthFade={3}
          farPlane={12}
          gamma={0.4545}
          variant="snowflake"
        />
      </div>

      <header className="testing5-header">
        <Link to="/" className="testing5-header__logo">
          DYLAN CHEN ZHEN
        </Link>
        <nav className="testing5-header__nav">
          <span className="testing5-header__link testing5-header__link--disabled">
            Projects
          </span>
          <Link to="/testing" className="testing5-header__link">
            Testing 1
          </Link>
          <Link to="/testing-2" className="testing5-header__link">
            Testing 2
          </Link>
          <Link to="/testing-3" className="testing5-header__link">
            Testing 3
          </Link>
          <Link to="/testing-4" className="testing5-header__link">
            Testing 4
          </Link>
          <Link to="/about" className="testing5-header__link">
            About
          </Link>
        </nav>
      </header>

      <main className="testing5-main">
        <span className="testing5-eyebrow">Testing 5</span>
        <h1 className="testing5-title">Pixel Snow</h1>
        <p className="testing5-subtitle">
          Snowflake variant shader study with a higher pixel grid for crisp
          flakes.
        </p>
      </main>
    </div>
  );
}
